window.ContinuousRouter = JunctionRouter.extend({
    initialize: function(container) {
        JunctionRouter.prototype.initialize.call(this, container);
        this.route("reset", "resetCourse");
    },

    resetCourse: function() {
        var self = this;
        this.resetPopup = new AccessibleBootbox({
            title: LanguageManager.getString("reset_title"),
            message: LanguageManager.getString("reset_text"),
            className: "reset-popup",
            animate: true,
            buttons: {
                okay: {
                    label: LanguageManager.getString("yes"),
                    className: "btn-primary",
                    callback: function() {
                        self.handleResetCourse();
                    }
                },
                cancle: {
                    label: LanguageManager.getString("no"),
                    className: "btn-primary",
                    callback: function() {
                        self.handleResetCancel();
                    }
                }
            }
        });

        this.resetPopup.popIn();
    },

    handleResetCourse: function() {
        this.destroyResetPopup();

        this.container.resetCourse();
        this.container.getComponent("SkillsManager").reset();
        this.container.getComponent("ActionsManager").reset();

        this.container.tracking.setCmiData("LESSON_STATUS", Status.COMPLETED_LABEL.toLowerCase());

        this.container.session.startModule(1);
    },

    handleResetCancel: function() {
        this.destroyResetPopup();
        this.navigate('reset-cancelled', {
            trigger: false
        });
    },

    destroyResetPopup: function() {
        if (this.resetPopup !== undefined) {
            this.resetPopup.destroy();
        }
        this.resetPopup = undefined;
    },

    previous: function() {
        var backId = this.container.session.currentPageData.getArg("showBack");
        var hasBack = this.container.courseData.getPageById(backId);
        if (hasBack) {
            this.navigate('page/' + backId, {
                trigger: false
            });
        } else {
            JunctionRouter.prototype.previous.call(this);
        }
    },

    next: function() {
        const response = this.trigger('beforeNext');
        var nextId = this.container.session.currentPageData.getArg("showNext");
        var hasNext = this.container.courseData.getPageById(nextId);
        if (hasNext) {
            this.navigate('page/' + nextId, {
                trigger: true
            });
        } else {
            JunctionRouter.prototype.next.call(this);
        }
    },
});
